import React from 'react';
import { Drawer as MuiDrawer, Box, Typography, IconButton, List, ListItem, ListItemButton, ListItemText, Divider, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LogoDarkIcon from '@/asset/logo_dark_icon_blue_accent_transparent.png';
import LogoLightIcon from '@/asset/logo_light_icon_transparent.png';
import Button from './Button';

export interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  navItems: { label: string; href: string }[];
  onNavigate: (href: string) => void;
}

export const Drawer: React.FC<MobileDrawerProps> = ({ open, onClose, navItems, onNavigate }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const drawerLogo = isDark ? LogoDarkIcon : LogoLightIcon;

  return (
    <MuiDrawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 300,
          backgroundColor: theme.palette.background.paper,
          borderLeft: `1px solid ${theme.palette.divider}`,
          p: 3,
          color: theme.palette.text.primary,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box component="img" src={drawerLogo} alt="Inverika Logo" sx={{ height: 40, width: 'auto' }} />
          <Typography
            variant="h6"
            sx={{
              fontFamily: "'BankGothic Md BT', 'BankGothic MD BT', 'Bank Gothic MD BT', 'Space Grotesk', sans-serif",
              fontWeight: 700,
              color: theme.palette.primary.main,
              letterSpacing: '0.01em',
              fontSize: '1.25rem',
            }}
          >
            Inverika
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: theme.palette.text.primary }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: theme.palette.divider, mb: 2 }} />

      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              onClick={() => {
                onNavigate(item.href);
                onClose();
              }}
              sx={{
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 102, 255, 0.1)' : 'rgba(0, 80, 203, 0.08)',
                  color: theme.palette.primary.main,
                },
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Box sx={{ mt: 'auto', pt: 3 }}>
        <Button
          fullWidth
          variant="contained"
          glow
          onClick={() => {
            onNavigate('/#contact');
            onClose();
          }}
        >
          Discuss Your Project
        </Button>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
